export default __webpack_public_path__ + "static/media/seat-standard.e9d07159.svg";